module.exports = __webpack_public_path__ + "static/media/S4N1-5.280fda00.svg";